
import { Component, Vue } from 'vue-property-decorator';
import { handleStoreIntegrationCallback } from '../../helpers/eCommerce';
import { AddStorePayload, PlatformType } from '../../types';

@Component
export default class CallbackEtsy extends Vue {
  get code(): string | null {
    return this.$route.query.code as string;
  }

  get state(): string | null {
    return this.$route.query.state as string;
  }

  async mounted() {
    if (!this.code || !this.state) return;

    const [shopUrl, newState] = this.state.split('***');

    const payload: AddStorePayload = {
      platformType: PlatformType.Etsy,
      inputFields: [
        { fieldId: 'StoreUrl', value: shopUrl },
        { fieldId: 'OauthVerifier', value: `${newState}***${this.code}` },
      ],
    };

    await handleStoreIntegrationCallback(payload);
  }
}
